import type { AxiosRequestConfig } from 'axios';

import { useClaim } from '../ClaimContainer';
import useDataFetcher from '../useDataFetcher';

export const useSharedCoverageConfigs = () => {
  const { claim } = useClaim({ claimRequired: true });
  const coverageConfigsParams: AxiosRequestConfig = {
    params: {
      sub_organization_ids: claim.policy?.sub_organization?.id ? [claim.policy.sub_organization.id] : [],
      lob: claim.lob,
      include_disabled: true,
    },
  };
  const {
    isLoading: isSharedCoverageConfigsLoading,
    isError: isSharedCoverageConfigsError,
    data: sharedCoverageConfigs = [],
    reloadData,
  } = useDataFetcher(`/api/v1/organizations/${claim.organization_id}/shared_coverage_configs`, coverageConfigsParams);

  return { isSharedCoverageConfigsLoading, isSharedCoverageConfigsError, sharedCoverageConfigs, reloadData };
};

export default useSharedCoverageConfigs;
